import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaStickyUtility from '@sparta.global.utilities/sparta-sticky-utility/dist/es6.js';
import sbCreditCardUtility from '@sparta.sb-credit-cards.utilities/sb-credit-card-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { is } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"is")||(depth0 && lookupProperty(depth0,"is"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cardId") : depth0),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"cardId") : stack1),{"name":"is","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":10},"end":{"line":11,"column":17}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "            <div class=\"details-section\">\r\n            </div>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"disclaimer") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row\">\r\n  <div class=\"column small-12\">\r\n    <div data-magellan-destination=\"productInterestRateSBCC\" class=\"foundation-sticky-destination\">\r\n      <h2 class=\"headline_title show-for-medium-up\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"headline") : stack1), depth0))
    + "</h2>\r\n      <div data-magellan-destination=\"productProductDetailsSBCC\" class=\"foundation-sticky-destination\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"catalogs") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":12,"column":17}}})) != null ? stack1 : "")
    + "      </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"disclaimer") : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":6},"end":{"line":16,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n  </div>\r\n\r\n<div class=\"data1-jcr\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":20,"column":33},"end":{"line":20,"column":47}}}))
    + "\"></div>\r\n<div class=\"catalogs-jcr\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"catalogs") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":21,"column":36},"end":{"line":21,"column":53}}}))
    + "\"></div>\r\n";
},"useData":true,"useDepths":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"className") : stack1), depth0))
    + " product-list-li small-12\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"mock") : depth0)) != null ? lookupProperty(stack1,"image") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":8,"column":15}}})) != null ? stack1 : "")
    + "\r\n        <div class=\"text-cont\">\r\n          <h4 class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"mock") : depth0)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":12,"column":21},"end":{"line":12,"column":69}}})) != null ? stack1 : "")
    + "\" role=\"heading\" aria-level=\"3\">\r\n            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n          </h4>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"mock") : depth0)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"each","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":10},"end":{"line":23,"column":19}}})) != null ? stack1 : "")
    + "        </div>\r\n      </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"image-cont\">\r\n            <img src=\"\" alt=\"\" data-image-url=\""
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"mock") : depth0)) != null ? lookupProperty(stack1,"image") : stack1), depth0)) != null ? stack1 : "")
    + "\" />\r\n          </div>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    return " ";
},"6":function(container,depth0,helpers,partials,data) {
    return " padding-h ";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <p>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"rate") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":14},"end":{"line":20,"column":21}}})) != null ? stack1 : "")
    + "              "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"p") || (depth0 != null ? lookupProperty(depth0,"p") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"p","hash":{},"data":data,"loc":{"start":{"line":21,"column":14},"end":{"line":21,"column":21}}}) : helper))) != null ? stack1 : "")
    + "\r\n            </p>\r\n";
},"9":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <span class=\"roboto-bold\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"rate") || (depth0 != null ? lookupProperty(depth0,"rate") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"rate","hash":{},"data":data,"loc":{"start":{"line":19,"column":42},"end":{"line":19,"column":52}}}) : helper)))
    + "</span>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"row product-list-details\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"partialContent") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":26,"column":13}}})) != null ? stack1 : "")
    + "</div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.sb-credit-cards.modules/product-product-details-sbcc-module",
  "version": "2.0.1",
  "id": "productProductDetailsSbccModule",
  "containerID": "sbCreditCardsProductProductDetailsSbccModule",
  "moduleName": "sb-credit-cards-product-product-details-sbcc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "product-product-details-sbcc-module",
  "data": {
    "init": "ProductProductDetailsSbccModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        is,
        json
      },
      "partials": {
        "details-partial": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "details-partial": renderTemplate
  },
  "helpers": {
    is,
    json
  },
  "dependencies": {
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-sticky-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.8",
    "@sparta.sb-credit-cards.utilities/sb-credit-card-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * The ProductProductDetailsSbccModule Sparta Module.
 * sparta generate module
 * @export
 * @class
 */
class ProductProductDetailsSbccModule extends Module {
  /**
   * Creates an instance of ProductProductDetailsSbccModule.
   * @param {Object} options // Module options
   * @param {Object} context // Module context
   * @memberof ProductProductDetailsSbccModule
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const {
      target
    } = this.settings;
    try {
      this.content = JSON.parse(target.querySelector('.data1-jcr').dataset.jcr);
      this.cardId = this.content.cardId;
      this.catalogPropsForCard = JSON.parse(target.querySelector('.catalogs-jcr').dataset.jcr)[this.cardId];
      this.detailParams = [{
        cardCatalogIdentifier: this.cardId,
        primaryIdentifier: this.catalogPropsForCard.campaignId,
        secondaryIdentifier: this.catalogPropsForCard.pocode,
        localeIdentifier: 'en_US'
      }];
      target.dataset.magellanDestination = target.dataset.init;
    } catch (exception) {
      console.error(exception);
    }
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @param {object} options The options this module was initialized with.
   * @returns {void}
   */
  init() {
    sbCreditCardUtility.productDetailMap(this.detailParams).then(resp => {
      const partialContent = sbCreditCardUtility.generateLinkContent(this.content, resp[this.cardId]);
      const {
        target
      } = this.settings;
      const renderedPartial = _moduleConfig.partials['details-partial']({
        partialContent
      });
      target.querySelector('.details-section').innerHTML = renderedPartial;
      this.setImageSrc();
      spartaStickyUtility.recalcStickyEls();
      if (document.getElementById('calculate_rewards')) {
        const calcRelativeHref = document.getElementById('calculate_rewards').getAttribute('href');
        const calculatorHref = `${spaParams.siteParams.calcDomain}${calcRelativeHref}`;
        document.getElementById('calculate_rewards').setAttribute('href', calculatorHref);
      }
    });
  }

  /**
   * @description Sets the image src via data attributes
   * @returns {void}
   */
  setImageSrc() {
    const images = this.settings.target.querySelectorAll('img');
    Array.from(images).forEach(i => {
      const url = i.dataSet.imageUrl;
      i.setAttribute('src', url);
    });
  }
}
registerModuleClass({
  moduleClass: ProductProductDetailsSbccModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ProductProductDetailsSbccModule as default, moduleConfig };
